export default "__VITE_ASSET__DqriC2jE__"